const state = {
  assets: [],
  uploadProgress: {
    index: 0,
    value: 0
  },
}

export default state;